import type { ISite } from "@similarweb/ui-components";

import { autocompleteStates } from "app/components/compare/WebsiteQueryBarTypes";
import { fetchWebsitesFaviconsQuery } from "app/services/sitesService/queries/sitesQueries";

export const entityTypeMap = {
    advertiser: "advertiser",
    publisher: "publisher",
} as const;
export type EntityType = keyof typeof entityTypeMap;

const autocompleteTypeMap = {
    query: "query",
    recent: "recent",
    suggestion: "suggestion",
} as const;
type AutocompleteType = keyof typeof autocompleteTypeMap;

export interface IAutocompleteItem {
    name: string;
    type: AutocompleteType;
    image: string;
    subType: EntityType;
    color?: string;
}

interface ISuggestedEntity {
    name: string;
}

export const suggestedEntities: ISuggestedEntity[] = [
    { name: "grammarly.com" },
    { name: "nike.com" },
    { name: "disneyplus.com" },
    { name: "dailymail.co.uk" },
    { name: "telegraph.co.uk" },
];

export const generateAutocompleteDefaultItems = async (
    suggestions: ISuggestedEntity[],
): Promise<ISite[] | autocompleteStates[]> => {
    try {
        const entitiesWithFavicons = await fetchWebsitesFaviconsQuery(suggestions.map((entity) => entity.name));
        return Object.entries(entitiesWithFavicons).map(([key, value]) => ({
            name: key,
            image: value,
            type: autocompleteTypeMap.suggestion,
            subType: entityTypeMap.advertiser,
        }));
    } catch (e) {
        return [autocompleteStates.ERROR];
    }
};
